module.exports = __webpack_public_path__ + "static/7-0e10a1534ba3041cb042093f12456487.png";